/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Ptz_LeftInputs */

const vi_grower_area_camera_ptz_left = /** @type {(inputs: Grower_Area_Camera_Ptz_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quay trái`)
};

/**

* @param {Grower_Area_Camera_Ptz_LeftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_ptz_left = /** @type {((inputs?: Grower_Area_Camera_Ptz_LeftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Ptz_LeftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_ptz_left(inputs)
});